const authProvider = {
  isAuthenticated: false,
  login(callback: VoidFunction) {
    authProvider.isAuthenticated = true;
    callback();
  },
  logout(callback: VoidFunction) {
    authProvider.isAuthenticated = false;
    callback();
  },
  onOffUpgradeNow(callback: VoidFunction) {
    authProvider.isAuthenticated = true;
    callback();
  },
  onOffUserEndedSubscription(callback: VoidFunction) {
    authProvider.isAuthenticated = true;
    callback();
  },
};

export { authProvider };
